import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="animate-fade-in bg-oya-cream min-h-screen flex flex-col items-center justify-center text-center px-4">
      <div className="relative mb-6">
        <span className="text-[8rem] md:text-[10rem] font-black text-oya-gray-light select-none leading-none">
          404
        </span>
      </div>
      <h1 className="text-2xl md:text-3xl font-bold text-oya-black mb-3">
        Page introuvable
      </h1>
      <p className="text-oya-gray-medium max-w-md mb-8 leading-relaxed">
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-8 py-3.5 bg-oya-red text-white font-medium rounded-full hover:bg-oya-red-dark transition-colors whitespace-nowrap"
      >
        <i className="ri-home-line" />
        Retour à l'accueil
      </Link>
    </div>
  );
}